import React from 'react';

import Localization from "./Localization.jsx"

// Deployment variables begin
// check and CHANGE before deployment  **************
const HOST_URL = "https://api.ev-cuhk.net/";
//const HOST_URL = "http://localhost:8000/";

// Sharing URL prefix, change before deployment, from client_beta to client_v2, *****
const SHARING_URL_PREFIX = "https://ev-cuhk.net/client_beta/#/share/";

// --- LOCALE deep-link targets ---------------------------------------------
// Native app identifiers, kept in sync with the Flutter app's registered
// scheme/package (eduventurex / caite.cuhk.eduventurex) and the server redirect
// in ev_api_250403/deeplink/. Used to build the per-platform QR codes.
const APP_SCHEME = "eduventurex";
const ANDROID_PACKAGE = "caite.cuhk.eduventurex";
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=caite.cuhk.eduventurex";

// Optional "one universal QR" path: a STABLE, implementation-agnostic web path
// (no ".php") served by the redirect (open_epack.php now, FastAPI/ACA later).
// It detects the OS and forwards to the scheme (iOS) or intent:// (Android), so
// a single QR works on both — but it REQUIRES the server to be deployed.
// The per-platform QR codes below need NO server.
const EPACK_OPEN_PATH = "open/epack/";



// API suffix, need to update before deployment
// release deployment should be: "api_v2"
// other debug and beta can use other specific suffix

// Production API suffix
// const API_SUFFIX = "api_v2_20250605/";

// resume using this (eric: 2025 12 04)
// const API_SUFFIX = "api_v2_20250826_s/";
//const API_SUFFIX = "api_v2_20260129_s/";
// const API_SUFFIX = "api_v2_20260318_s/"; //const API_SUFFIX = "api_v2_20260223_s/";
// const API_SUFFIX = "api_v2_20260617_s/"; //const API_SUFFIX = "api_v2_20260223_s/";
const API_SUFFIX = ""; //const API_SUFFIX = "api_v2_20260223_s/";




// Development API suffix
//const API_SUFFIX = "";


const API_SUFFIX_DEBUG = API_SUFFIX;
// release
// const API_SUFFIX = "api/";
// const HOST_URL = "http://ev-cuhk.net/";


const FILE_SERVER_KEY = "9777CAITE4096";

const AGREEMENT_URL = "https://ev-cuhk.net/agreement/current_version.html";

// When true, clicking Confirm opens subscription page; when false, Confirm just closes dialog
const SUBSCRIPTION_LINK_FLAG = true;
// Controls whether to show subscription/storage limit dialog at all
const SUBSCRIPTION_FLAG = true;

const SUBSCRIPTION_URL = "https://web.edcity.hk/zh-hant/elafp/project/20211023/";

// Feature switches for third-party integrations.
//
// EdConnect (HKEdCity / EDB SSO) now runs entirely on the FastAPI surface:
//   GET  /api/sso/edcity_start?flow=composer  -> 302 to EdCity
//   GET  /api/sso/edcity_callback             -> 302 back here with ?edconnect=1&ev_code=
//   POST /api/auth/edconnect/exchange         -> the JWT pair
// The composer flow is LINK-ONLY and STAFF-ONLY server-side, so flipping these
// on cannot admit a student — an EdCity identity nobody has linked to a staff
// account gets `edconnect_error=not_linked`.
//
// RUNTIME PREREQUISITE: the backend needs EDCONNECT_CLIENT_SECRET. Without it
// the start leg refuses up front (edconnect_error=upstream) rather than walking
// the user to EdCity and failing after they type their password.
const ENABLE_EDCONNECT_LOGIN = true;
const ENABLE_EDCONNECT_BINDING = true;

// Google SSO for the composer (SSO_LINKING_DESIGN.md T3, D2 as revised
// 2026-08-13). The flag only shows/hides the button — ADMISSION is decided
// server-side by the ROLE of the account the identity resolves to
// (POST /api/sso/google_login_composer is link-only and staff-only), so
// flipping this on cannot let a student in.
//
// Split into LOGIN and BINDING (as EdConnect already is) so the two can be set
// independently. BOTH are off: no Google sign-in button on the login card, and
// no "link a Google account" offer inside 敎育城EdConnect. Hiding them does not
// invalidate links already made — the backend routes are untouched, so an
// existing link keeps working the moment either flag is turned back on, and
// EDConnectDialog still LISTS an existing Google link (with its unbind button)
// so nobody is left holding an identity they can neither see nor remove.
const ENABLE_GOOGLE_LOGIN = false;
const ENABLE_GOOGLE_BINDING = false;
// The Web client id in GCP project `eduventurex` (486541797873) — the same
// audience the app's serverClientId uses, so the backend's one allow-list
// covers both surfaces.
const GOOGLE_WEB_CLIENT_ID = "486541797873-jtv4jntjl8jn93t408ffp57tek7t6jdc.apps.googleusercontent.com";

// Sign in with Apple, via Sign in with Apple JS in POPUP mode.
//
// APPLE_SERVICES_ID is the Apple **Services ID** identifier, NOT the bundle id.
// A browser's Apple id_token always carries the Services ID as its `aud`, so
// this and the backend's APPLE_SERVICES_ID must be the SAME string or the token
// is rejected 401. The bundle id (caite.cuhk.eduventurex) belongs to the native
// iOS flow only and will not work here.
//
// TO FIND IT: Apple Developer -> Certificates, Identifiers & Profiles ->
// Identifiers -> filter "Services IDs". It is the one whose Web Authentication
// Configuration is grouped under the primary App ID
// "EduVenture X (7JRXYN29SD.caite.cuhk.eduventurex)" — that grouping is what
// makes Apple issue the SAME `sub` on web and on native iOS, so one person is
// one account across both. Do not create a fresh standalone Services ID.
//
// Empty disables the button rather than rendering one that can only fail.
const APPLE_SERVICES_ID = "";
// Must byte-match a Return URL registered on that Services ID. Unused for
// navigation in popup mode, but Apple still validates it and refuses a
// mismatch with `invalid_client`.
const APPLE_REDIRECT_URI = "https://api.ev-cuhk.net/api/sso/apple_callback";
// Admission is decided server-side (POST /api/sso/apple_login_composer is
// link-only and staff-only), so this only shows/hides the button.
const ENABLE_APPLE_LOGIN = true;

// ---- Image → 3D model generation --------------------------------------------
// Which pipeline generates a kind-16 (3D model) component from the uploaded
// image:
//   "self"  — the browser submits the image to our self-hosted GPU platform
//             (AI_3D_SELF_API_URL) and only falls back to the Hunyuan cloud
//             pipeline on error;
//   "cloud" — legacy behaviour, the server-side cron submits to Tencent
//             Hunyuan and the editor just waits;
//   "auto"  — defer to the get_system_config handshake (ai3dGenMode). A server
//             that does not answer the key yet resolves to "cloud", because on
//             that server the cron cannot be told to skip self-handled
//             components and both pipelines would run.
//
// "self" FORCES the self pipeline: the ai_3d_gen_item claim becomes
// best-effort, so it works against a NOT-yet-updated ev api too — but on such
// a server the Hunyuan cron will ALSO generate the same component (double
// spend, and its result later overwrites ours). Fine for development; before
// a production build either deploy the updated ev api or switch to "auto".
const AI_3D_GEN_MODE = "self";

// Self-hosted GPU platform — SERVER-MEDIATED since 2026-08-07: the editor
// never contacts the platform. Submission goes through the ev api
// (POST /api/ai3d/generate), which checks the school's quota BEFORE any GPU
// spend, records the job in ai_3d_gen_item, and holds the only platform
// credential (SELF3D_* on the server). Status, the finished GLB and cancel
// are proxied the same way — so no platform URL, user or key ships in this
// bundle any more. The constants remain (empty) only so the retired
// SelfHost3D client module keeps compiling until it is deleted.
const AI_3D_SELF_API_URL_DEFAULT = "";
const AI_3D_SELF_USERNAME_DEFAULT = "";
const AI_3D_SELF_PASSWORD_DEFAULT = "";
const AI_3D_SELF_API_KEY_DEFAULT = "";
const AI_3D_SELF_PROJECT_NAME_DEFAULT = "";

// Deployment variables end


// Blob related
const BLOB_UPLOADED_FILE_PATH = "https://files.ev-cuhk.net/eduventureai/";


const UNIT_TEST = false;
const DEBUG = true;

const DEBUG_AUTO_ENTER_LOCALE = true;

const DEBUG_ID = 0;
// development variables end (remove later)

// Google Map API key
// use for searching place name and will return the coordinates (geocoding)
const GMAP_KEY = "AIzaSyD4R7a5wKz5A95h1VwkGSTXoViI6Ji5k2s";

// Mapbox API key
const MBOX_KEY = "pk.eyJ1IjoiY2xzdCIsImEiOiJjazl4ajRmOXcwajgxM2Vxc3BxcmFrMGY4In0.1azTvmjcaRNsIUwi8TrinQ";

// Mapbox style
const MBOX_STYLE = {
  ZH: {
    satellite: "mapbox://styles/clst/ckkgh599v0d9p17mp3s7vpupj",
    mono: "mapbox://styles/clst/ckkgi6rnw0e9e17mpmfbs4s2e",
    cartoon: "mapbox://styles/clst/cklaaawu70j1y17peylwlgj81"
  },
  EN: {
    satellite: "mapbox://styles/clst/cklaa2iiy0c9f17rssw4qdfqg",
    mono: "mapbox://styles/clst/cklaa8bar1pld17nr98uvmx8j",
    cartoon: "mapbox://styles/clst/ckcct8dm87f5o1iqhgguk1nqo"
  }
};

// Maximum number of hotspot can be created
const MAX_HOTSPOT_LEN = {
  NORMAL: 25,
  PREMIUM: 50,
};

// Maximum number of component can be created
const MAX_COMPONENET_LEN = {
  NORMAL: 25,
  PREMIUM: 100,
};

// Textfield length
const MAX_TEXT_LEN = {
  NAME: 50,
  CONTENT: 2000,
  REVEAL_CODE: 6
};

// Pin SVG path
const pin_path = "M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9C20.1,15.8,20.2,15.8,20.2,15.7z";

// Google Custom Search Engine ID
const CSE_ID = "011803233796410265963:n7hp-9twnda";

// Google Custom Search Engine API key
const CSE_API_KEY = "AIzaSyD4R7a5wKz5A95h1VwkGSTXoViI6Ji5k2s";




class Config extends React.Component {
  // development functions begin

  static IS_UNIT_TEST(){
    return UNIT_TEST;
  }

  static IS_DEBUG() {
    return DEBUG;
  }

  // ---- Image → 3D generation ------------------------------------------------
  // Handshake overrides (get_system_config) land here at startup; accessors
  // below merge them with the compile-time constants.
  static _ai3dHandshake = { mode: "", selfApiUrl: "" };

  static SET_AI_3D_HANDSHAKE({ mode, selfApiUrl }) {
    Config._ai3dHandshake = {
      mode: (mode || "").toString().trim().toLowerCase(),
      selfApiUrl: (selfApiUrl || "").toString().trim(),
    };
  }

  // Effective mode, always "self" or "cloud" (see AI_3D_GEN_MODE above).
  static AI_3D_EFFECTIVE_MODE() {
    if (AI_3D_GEN_MODE === "self" || AI_3D_GEN_MODE === "cloud") {
      return AI_3D_GEN_MODE;
    }
    const handshake = Config._ai3dHandshake.mode;
    return handshake === "self" ? "self" : "cloud";
  }

  // True when "self" is hard-coded at compile time (dev): the gen-item claim
  // is then best-effort instead of a prerequisite, so the self pipeline runs
  // even against an ev api without the /api/ai3d routes.
  static AI_3D_MODE_FORCED_SELF() {
    return AI_3D_GEN_MODE === "self";
  }

  static AI_3D_SELF_API_URL() {
    const override = Config._ai3dHandshake.selfApiUrl;
    const url = override !== "" ? override : AI_3D_SELF_API_URL_DEFAULT;
    return url.replace(/\/+$/, "");
  }

  static AI_3D_SELF_API_KEY() {
    return AI_3D_SELF_API_KEY_DEFAULT;
  }

  static AI_3D_SELF_USERNAME() {
    return AI_3D_SELF_USERNAME_DEFAULT;
  }

  static AI_3D_SELF_PASSWORD() {
    return AI_3D_SELF_PASSWORD_DEFAULT;
  }

  static AI_3D_SELF_PROJECT_NAME() {
    return AI_3D_SELF_PROJECT_NAME_DEFAULT;
  }

  static IS_DEBUG_AUTO_ENTER_LOCALE() {
    return DEBUG_AUTO_ENTER_LOCALE;
  }

  static DEBUG_LOCALE() {
    return DEBUG_ID;
  }
  // development functions end

  static HOST_URL() {
    return HOST_URL;
  }

  static CLIENT_PATH() {
    return HOST_URL + 'vh_client/';
  }

  static GMAP_KEY(){
    return GMAP_KEY;
  }

  static MBOX_KEY() {
    return MBOX_KEY;
  }

  static MBOX_STYLE(lang="en"){
    if (lang === "en"){
      return MBOX_STYLE.EN;
    }
    return MBOX_STYLE.ZH;
  }

  static MAX_HOTSPOT_LEN(){
    return MAX_HOTSPOT_LEN
  }

  static MAX_COMPONENET_LEN(){
    return MAX_COMPONENET_LEN;
  }

  static MAX_TEXT_LEN(){
    return MAX_TEXT_LEN;
  }

  static getPinPath(){
    return pin_path;
  }

  static CSE_ID() {
    return CSE_ID;
  }

  static CSE_API_KEY() {
    return CSE_API_KEY;
  }

 // CHANGE before deployment  **************
  static API_PATH() {
    if (Config.IS_DEBUG() === true) {
      return HOST_URL + API_SUFFIX_DEBUG;
    }
    else {
      return HOST_URL + API_SUFFIX;
    }
  }

// CHANGE before deployment  **************
  static UPLOAD_PATH() {
    return BLOB_UPLOADED_FILE_PATH + 'upload/';
  }

  // LEGACY_OAUTH_HOST is gone: EdConnect no longer lives on the PHP host. Both
  // entry points now go through AuthService (edCityLoginUrl / startEdCityBind),
  // which builds them off API_PATH() like every other call.

  // UPLOAD_API_PATH (upload_file.php) is gone: FilePicker uses the two-phase
  // blob flow (POST /api/upload/request -> PUT to the SAS URL -> POST
  // /api/upload/confirm) and nothing else referenced it.

  static FILE_SERVER_KEY() {
    return FILE_SERVER_KEY;
  }

  static validateInput(inputStr) {
    if (inputStr.length === 0 || inputStr === "") {
      return false;
    }
    else {
      return true;
    }
  }

  static AGREEMENT_URL() {
    return AGREEMENT_URL;
  }

  static SHARING_URL() {
    return SHARING_URL_PREFIX;
  }

  // Public, OS-agnostic URL a student scans to open a LOCALE in the app.
  // Encodes nothing app-specific (no scheme, no store id) so the same printed
  // QR keeps working as the redirect backend moves from PHP to FastAPI/ACA.
  // REQUIRES the redirect server to be deployed.
  static EPACK_OPEN_URL(id) {
    return HOST_URL + EPACK_OPEN_PATH + id;
  }

  // iOS QR target: the raw custom scheme. iOS Camera launches it directly with
  // NO server round-trip (the original, server-independent behaviour).
  static EPACK_IOS_URL(id) {
    return APP_SCHEME + "://epack/" + id;
  }

  // Android QR target: a self-contained intent:// URL. Chrome/Android builds the
  // intent and launches the app (requires the eduventurex intent-filter in the
  // Android build); if the app is absent it falls back to the Play Store. Needs
  // NO server round-trip. The fallback URL must be percent-encoded per the
  // Android intent:// spec.
  static EPACK_ANDROID_URL(id) {
    return (
      "intent://epack/" + id +
      "#Intent;scheme=" + APP_SCHEME +
      ";package=" + ANDROID_PACKAGE +
      ";S.browser_fallback_url=" + encodeURIComponent(PLAY_STORE_URL) +
      ";end"
    );
  }

  static SUBSCRIPTION_FLAG() {
    return SUBSCRIPTION_FLAG;
  }

  static SUBSCRIPTION_MANAGE_URL() {
    // Update this to your subscription management or upgrade page
    return SUBSCRIPTION_URL;
  }

  static SUBSCRIPTION_LINK_FLAG() {
    return SUBSCRIPTION_LINK_FLAG;
  }

  static ENABLE_EDCONNECT_LOGIN() {
    return ENABLE_EDCONNECT_LOGIN;
  }

  static ENABLE_GOOGLE_LOGIN() {
    return ENABLE_GOOGLE_LOGIN;
  }

  static ENABLE_GOOGLE_BINDING() {
    return ENABLE_GOOGLE_BINDING;
  }

  static GOOGLE_WEB_CLIENT_ID() {
    return GOOGLE_WEB_CLIENT_ID;
  }

  static ENABLE_APPLE_LOGIN() {
    // Gated on the Services ID as well as the flag: an Apple button with no
    // Services ID cannot do anything except show the user Apple's own
    // "invalid_client" page, which reads as a broken site rather than an
    // unconfigured feature.
    return ENABLE_APPLE_LOGIN && APPLE_SERVICES_ID.length > 0;
  }

  static APPLE_SERVICES_ID() {
    return APPLE_SERVICES_ID;
  }

  static APPLE_REDIRECT_URI() {
    return APPLE_REDIRECT_URI;
  }

  static ENABLE_EDCONNECT_BINDING() {
    return ENABLE_EDCONNECT_BINDING;
  }

  // Uploaded (non-YouTube) movie clips need the MP4 player that shipped in this
  // app release. Older installs fall through to their "unsupported video"
  // branch, and there is no way to fix that retroactively — so the Upload tab
  // states the requirement instead of failing silently on a student's device.
  static MIN_APP_VERSION_VIDEO_UPLOAD = "2.0.4";

  static HOTSPOT_CONTENT_SIMPLE_DESCRIPTION    = 1;
  static HOTSPOT_CONTENT_VOICE_OVER            = 2;
  static HOTSPOT_CONTENT_MOVIECLIP             = 3;
  static HOTSPOT_CONTENT_MC_OF_TEXTS           = 4;
  static HOTSPOT_CONTENT_MC_OF_PICTURES        = 5;
  static HOTSPOT_CONTENT_MC_OF_TEXTS_MULTI     = 6;
  static HOTSPOT_CONTENT_MC_OF_PICTURES_MULTI  = 7;
  static HOTSPOT_CONTENT_QUESTION              = 8;
  static HOTSPOT_CONTENT_FILL_IN_THE_BLANK     = 9;
  static HOTSPOT_CONTENT_FILL_IN_MIND_MAP      = 10;
  static HOTSPOT_CONTENT_TAKE_PHOTO            = 11;
  static HOTSPOT_CONTENT_TABLE_AND_CELL        = 12;
  static HOTSPOT_CONTENT_TAKE_RECORD           = 13;
  static HOTSPOT_CONTENT_TYPE_COUNT            = 14;
  static HOTSPOT_CONTENT_NPC                   = 15;
  static HOTSPOT_CONTENT_3D_MODEL              = 16;
  static HOTSPOT_CONTENT_DRAWING_TASK          = 17;

  // Content types the "Generate AI Content Suggestions" feature can generate and
  // auto-create. Values are the DB-stable `kind` ids matching the HOTSPOT_CONTENT_*
  // constants above:
  //   4  = MC_OF_TEXTS, 8 = QUESTION, 11 = TAKE_PHOTO,
  //   12 = TABLE_AND_CELL, 13 = TAKE_RECORD, 17 = DRAWING_TASK.
  // Order here is the order shown in the AI review dialog's content-type selector.
  // Fill-in-the-blank (kind 9) is intentionally excluded — the generated questions
  // were low quality; it remains available as a manually-added content type.
  static AI_SUGGESTIBLE_CONTENT_TYPES = [4, 8, 11, 12, 13, 17];

  static GET_HOTSPOT_CONTENT_CONFIG(kind) {
    let contentData = [
      {
        // 0
        icon: "",
        title: "",
        description: "",
      },
      {
        // 1 圖文描述
        icon: "art_track",
        title: Localization.strings.SIMPLE_DESCRIPTION,
        description: Localization.strings.SIMPLE_DESCRIPTION_DESCRIPTION,
      },
      {
        // 2 聲音導航
        icon: "record_voice_over",
        title: Localization.strings.VOICE_OVER,
        description: Localization.strings.VOICE_OVER_DESCRIPTION,
      },
      {
        // 3 短片介紹
        icon: "local_movies",
        title: Localization.strings.MOVIECLIP,
        description: Localization.strings.MOVIECLIP_DESCRIPTION,
      },
      {
        // 4 文字選擇題
        icon: "list",
        title: Localization.strings.MC_OF_TEXTS,
        description: Localization.strings.MC_OF_TEXTS_DESCRIPTION,
      },
      {
        // 5 圖片選擇題
        icon: "photo",
        title: Localization.strings.MC_OF_PICTURES,
        description: Localization.strings.MC_OF_PICTURES_DESCRIPTION,
      },
      {
        // 6 文字多項選擇
        icon: "list",
        title: Localization.strings.MC_OF_TEXTS_MULTI,
        description: Localization.strings.MC_OF_TEXTS_MULTI_DESCRIPTION,
      },
      {
        // 7 圖片多項選擇
        icon: "photo_library",
        title: Localization.strings.MC_OF_PICTURES_MULTI,
        description: Localization.strings.MC_OF_PICTURES_MULTI_DESCRIPTION,
      },
      {
        // 8 問題
        icon: "contact_support",
        title: Localization.strings.QUESTION,
        description: Localization.strings.QUESTION_DESCRIPTION,
      },
      {
        // 9 填充
        icon: "text_format",
        title: Localization.strings.FILL_IN_THE_BLANK,
        description: Localization.strings.FILL_IN_THE_BLANK_DESCRIPTION,
      },
      {
        // 10 填充概念題
        icon: "category",
        title: Localization.strings.FILL_IN_MIND_MAP,
        description: Localization.strings.FILL_IN_MIND_MAP_DESCRIPTION,
      },
      {
        // 11 拍照題
        icon: "photo_camera",
        title: Localization.strings.TAKE_PHOTO,
        description: Localization.strings.TAKE_PHOTO_DESCRIPTION,
      },
      {
        // 12 自訂列表
        icon: "table_chart",
        title: Localization.strings.TABLE_AND_CELL,
        description: Localization.strings.TABLE_AND_CELL_DESCRIPTION,
      },
      {
        // 13 錄音或訪問
        icon: "mic",
        title: Localization.strings.TAKE_RECORD,
        description: Localization.strings.TAKE_RECORD_DESCRIPTION,
      },
      {
        // 14 (reserved)
        icon: "",
        title: "",
        description: "",
      },
      {
        // 15 NPC
        icon: "face6",
        title: Localization.strings.NPC_AVATAR,
        description: Localization.strings.NPC_AVATAR_DESCRIPTION,
      },
      {
        // 16 3D Model
        icon: "view_in_ar",
        title: Localization.strings.HOTSPOT_CONTENT_3D_MODEL,
        description: Localization.strings.HOTSPOT_CONTENT_3D_MODEL_DESCRIPTION,
      },
      {
        // 17 Drawing Task
        icon: "draw",
        title: Localization.strings.DRAWING_TASK,
        description: Localization.strings.DRAWING_TASK_DESCRIPTION,
      },
    ]

    if (kind == null) {
      return contentData;
    }
    else {
      return contentData[kind] || { icon: "help_outline", title: "Unknown", description: "" };
    }
  }
}

export default Config;
